import { Component, Input, HostListener, EventEmitter, Output } from '@angular/core';

@Component({
	selector: 'hhsg-shared-modal',
	templateUrl: 'modal.component.html',
	styleUrls: ['modal.component.scss']
})
export class HhsgSharedModalComponent {
	@Input() isActive: boolean;
	@Input() isWide: boolean = false;

	@Input() disableHeader: boolean = false;
	@Input() header: string;

	@Input() body: string;

	@Input() disableFooter: boolean = false;
	@Input() footer: string;

	@Input() allowEscape: boolean = false;

	@Input() acceptText: string;
	@Input() rejectText: string;

	@Input() type: string = 'default';

	@Output() closeEvent: EventEmitter<string> = new EventEmitter<string>();
	@Output() acceptEvent: EventEmitter<any> = new EventEmitter<any>();
	@Output() rejectEvent: EventEmitter<any> = new EventEmitter<any>();

	@HostListener('document:keydown', ['$event']) onKeyDown(evt: any) {
		if (this.allowEscape && evt.key === 'Escape') {
			this.onDismiss('escape');
		}
	}

	onAccept(): boolean {
		this.acceptEvent.emit('accept');

		return false;
	}

	onReject(): boolean {
		this.rejectEvent.emit('reject');

		return false;
	}

	private onDismiss(closeEvent: string): void {
		this.isActive = false;
		this.closeEvent.emit(closeEvent);
	}
}
